import React from "react";
import {
  DELETE_ORDER,
  GET_ORDER,
  UPDATE_ORDER,
  PRINT_RECEIPT,
  ENABLE_DISABLE_FORM,
  GET_FORM_DETAILS,
  GET_EXPORT_ORDERS,
  GET_BUSINESS_ORDER_NOTIFICATION_DETAILS,
  SAVE_BUSINESS_ORDER_NOTIFICATION_DETAILS,
  STRIPE_REFUND,
} from "../Actions/actionTypes";
import _ from "lodash";
import addNotification from "react-push-notification";
import { history } from "../store";
import { routeName } from "../Service/env";
import { audioFunc } from "../Service/helper";
import sound from "../Sounds/newOrder.mp3";

const initial = {
  results: {
    Order: [],
  },
};

export default (state = initial, action) => {
  if (action.type === GET_ORDER) {
    const orderCount = localStorage.getItem("orderCount");

    if (
      orderCount !== null &&
      orderCount !== "" &&
      orderCount !== "undefined"
    ) {
      if (
        action.formType === "jotform"
          ? action.payload && action.payload.length > Number(orderCount)
          : Number(action.totalOrders) > Number(orderCount)
      ) {
        if (
          !document.hasFocus() ||
          !window.location.pathname.includes("Order")
        ) {
          audioFunc(false, false, sound);
          addNotification({
            title: "",
            message: (
              action.formType === "jotform"
                ? action.payload.length - Number(orderCount) === 1
                : Number(action.totalOrders) - Number(orderCount) === 1
            )
              ? "You have a new order!"
              : "You have new orders!",
            theme: "red",
            native: !document.hasFocus() ? true : false, // true : "Browser Notification" , False "Custom Notification"
            backgroundTop: "#BF2129", //'#A534A6', //optional, background color of top container.
            backgroundBottom: "#d82c33", //'#b764ac', //optional, background color of bottom container.
            silent: true,
            duration: 17000,
            onClick: function () {
              console.log("reducer order");
              if (!document.hasFocus()) {
                window.focus();
                history.push(`/${routeName}/Dashboard/Orders`);
                //this.close();
              }
            },
          });
          localStorage.setItem(
            "orderCount",
            action.formType === "jotform"
              ? action.payload.length
              : action.totalOrders
          );
        } else {
          audioFunc(false, true, sound);
          localStorage.setItem(
            "newOrderCount",
            action.formType === "jotform"
              ? action.payload.length - orderCount
              : action.totalOrders - orderCount
          );
        }
      }
    } else {
      localStorage.setItem(
        "orderCount",
        action.formType === "jotform"
          ? action.payload.length
          : action.totalOrders
      );
    }
    return _.cloneDeep({
      ...state,
      order: action.payload,
      totalOrders: action.totalOrders,
      totalAmount: action.totalAmount,
      dropDownValue: action.dropDownValue,
    });
  } else if (action.type === GET_EXPORT_ORDERS) {
    return _.cloneDeep({ ...state, exportOrders: action.payload });
  } else if (action.type === DELETE_ORDER) {
    return _.cloneDeep({ ...state, deleteOrder: action.payload });
  } else if (action.type === UPDATE_ORDER) {
    return _.cloneDeep({ ...state, updateOrder: action.payload });
  } else if (action.type === PRINT_RECEIPT) {
    return _.cloneDeep({ ...state, updateOrder: action.payload });
  } else if (action.type === ENABLE_DISABLE_FORM) {
    return _.cloneDeep({ ...state, enabledisableForm: action.payload });
  } else if (action.type === GET_FORM_DETAILS) {
    return _.cloneDeep({ ...state, form: action.payload });
  } else if (action.type === GET_BUSINESS_ORDER_NOTIFICATION_DETAILS) {
    return _.cloneDeep({ ...state, form: action.payload });
  } else if (action.type === SAVE_BUSINESS_ORDER_NOTIFICATION_DETAILS) {
    return _.cloneDeep({ ...state, form: action.payload });
  } else if (action.type === STRIPE_REFUND) {
    return _.cloneDeep({ ...state, form: action.payload });
  } else {
    return state;
  }
};
